import { DateRangeCalendar } from 'components/DateRangePicker'
import { TextField, Dropdown } from 'monday-ui-react-core'
import { Col } from 'react-bootstrap'
import './PayoutAllStatements.scss'

export function PayoutAllStatementAdvanceSearchForm({
    setSelectedReportingMonthDates,
    setSenderName,
    setPropertyNumber,
    setPayoutId,
    setPropertyName,
    setPayoutName,
    setOwnerNumber,
    setOwnerName,
    type,
    runNameOptions,
    setRunNames,
    runNames,
    reportingMonthFrom,
    reportingMonthTo
}) {
    
    return (
        <>
            <Col lg={12} className="d-none d-lg-block mb-5">
                <div className="d-flex gap-3 advance-search-container">
                    <Col className="d-flex flex-column gap-3">
                        {type !== 'sender' ? (
                            <>
                                <div>
                                    <label className="fw-bold" htmlFor="senderName">
                                        Sender Name
                                    </label>
                                    <TextField
                                        id="senderName"
                                        name="senderName"
                                        value={''}
                                        onChange={setSenderName}
                                        placeholder="Sender Name"
                                        size={TextField.sizes.SMALL}                                       
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                        <div>
                            <label className="fw-bold" htmlFor="reportingMonth">
                                Reporting Month
                            </label>
                            <DateRangeCalendar
                                size={TextField.sizes.SMALL}
                                onChange={setSelectedReportingMonthDates}
                                from={reportingMonthFrom}
                                to={reportingMonthTo}
                            />
                        </div>
                        {
                        type === 'sender' ? (
                        <div>
                            <label className="fw-bold" htmlFor="runName">
                                Run Name(s)
                            </label>
                            <Dropdown
                                defaultValue={[]}
                                options={runNameOptions}
                                value={runNames}
                                onChange={setRunNames}
                                placeholder="Run Name(s)"
                                multi
                                size="small"                                
                                className="dropdown-stories-styles_with-chips"
                                />
                        </div>
                        ) : (
                            <></>
                        )}
                    </Col>
                    <Col className="d-flex flex-column gap-3">
                        <div>
                            <label className="fw-bold" htmlFor="payoutID">
                                Payout ID
                            </label>
                            <TextField
                                id="payoutID"
                                name="payoutID"
                                value={''}
                                onChange={setPayoutId}
                                placeholder="Payout ID"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                        <div>
                            <label className="fw-bold" htmlFor="propertyNumber">
                                Property Number
                            </label>
                            <TextField
                                id="propertyNumber"
                                name="propertyNumber"
                                value={''}
                                onChange={setPropertyNumber}
                                placeholder="Property Number"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                        <div>
                            <label className="fw-bold" htmlFor="ownerNumber">
                                Owner Number
                            </label>
                            <TextField
                                id="ownerNumber"
                                name="ownerNumber"
                                value={''}
                                onChange={setOwnerNumber}
                                placeholder="Owner Number"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                    </Col>
                    <Col className="d-flex flex-column gap-3">
                    <div>
                            <label className="fw-bold" htmlFor="payoutName">
                                Payout Name
                            </label>
                            <TextField
                                id="payoutName"
                                name="payoutName"
                                value={''}
                                onChange={setPayoutName}
                                placeholder="Payout Name"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                        <div>
                            <label className="fw-bold" htmlFor="propertyName">
                                Property Name
                            </label>
                            <TextField
                                id="propertyName"
                                name="propertyName"
                                value={''}
                                onChange={setPropertyName}
                                placeholder="Property Name"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                        <div>
                            <label className="fw-bold" htmlFor="ownerName">
                                Owner Name
                            </label>
                            <TextField
                                id="ownerName"
                                name="ownerName"
                                value={''}
                                onChange={setOwnerName}
                                placeholder="Owner Name"
                                size={TextField.sizes.SMALL}
                            />
                        </div>
                    </Col>
                </div>
            </Col>
            <Col xs={12} className="d-lg-none d-xs-block d-md-block mb-5">
                <div className="advance-search-container">
                    <div>
                        <label className="fw-bold" htmlFor="reportingMonth">
                            Reporting Month
                        </label>
                        <DateRangeCalendar
                            style={{
                                height: '15px',
                            }}
                            onChange={setSelectedReportingMonthDates}
                            from={reportingMonthFrom}
                            to={reportingMonthTo}
                        />
                    </div>
                    {
                        type === 'sender' ? (
                        <div className="mt-3">
                            <label className="fw-bold" htmlFor="runName">
                                Run Name(s)
                            </label>
                            <Dropdown
                                defaultValue={[]}
                                options={runNameOptions}
                                value={runNames}
                                onChange={setRunNames}
                                placeholder="Run Name(s)"
                                multi
                                size="small"                                
                                className="dropdown-stories-styles_with-chips"
                                />
                        </div>
                        ) : (
                            <></>
                        )}
                    {type !== 'sender' ? (
                        <>
                            <div>
                                <label
                                    className="fw-bold mt-3"
                                    htmlFor="senderName"
                                >
                                    Sender Name
                                </label>
                                <TextField
                                    id="senderName"
                                    name="senderName"
                                    value={''}
                                    onChange={setSenderName}
                                    placeholder="Sender Name"
                                    size={TextField.sizes.SMALL}
                                />
                            </div>
                        </>
                    ) : (
                        <></>
                    )}
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="payoutID">
                            Payout ID
                        </label>
                        <TextField
                            id="payoutID"
                            name="payoutID"
                            value={''}
                            onChange={setPayoutId}
                            placeholder="Payout ID"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="payoutName">
                            Payout Name
                        </label>
                        <TextField
                            id="payoutName"
                            name="payoutName"
                            value={''}
                            onChange={setPayoutName}
                            placeholder="Payout Name"
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="propertyNumber">
                            Property Number
                        </label>
                        <TextField
                            id="propertyNumber"
                            name="propertyNumber"
                            value={''}
                            onChange={setPropertyNumber}
                            placeholder="Property Number"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="propertyName">
                            Property Name
                        </label>
                        <TextField
                            id="propertyName"
                            name="propertyName"
                            value={''}
                            onChange={setPropertyName}
                            placeholder="Property Name"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="ownerNumber">
                            Owner Number
                        </label>
                        <TextField
                            id="ownerNumber"
                            name="ownerNumber"
                            value={''}
                            onChange={setOwnerNumber}
                            placeholder="Owner Number"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                    <div className="mt-3">
                        <label className="fw-bold" htmlFor="ownerName">
                            Owner Name
                        </label>
                        <TextField
                            id="ownerName"
                            name="ownerName"
                            value={''}
                            onChange={setOwnerName}
                            placeholder="Owner Name"
                            size={TextField.sizes.SMALL}
                        />
                    </div>
                </div>
            </Col>
        </>
    )
}
